import { IPayloadAction, ScannerActions } from '../scanner/scanner.actions';

export interface IPolicy {
  apiPolicy: string;
}

export function policyReducer(state: IPolicy, action: IPayloadAction) {

  switch (action.type) {

    case ScannerActions.API_POLICY_RECEIVED:
      return {
        ...state,
        apiPolicy: action.payload,
      };

    default:
      return state;

  }
}
